import React, { FC, HTMLAttributes } from 'react';
import { StyledButton, StyledButtonOutline, ButtonSize } from './styles';

export interface ButtonProps extends HTMLAttributes<HTMLButtonElement>  {
    style?: React.CSSProperties;
    onClick?: (event?: React.MouseEvent<any>) => void;
    disabled?: boolean;
    size?: ButtonSize;
    color?: string;
    backgroundColor?: string;
    outline?: boolean;
    type?: 'button' | 'submit' | 'reset';
}

const Button: FC<ButtonProps> = ({
    children,
    size = ButtonSize.md,
    disabled = false,
    outline,
    color = outline ? '#47516f' : '#FFF',
    backgroundColor = '#47516f',
    type = 'button',
    ...rest
}) => {
    return !outline ? (
        <StyledButton
            backgroundColor={backgroundColor}
            color={color}
            disabled={disabled}
            size={size}
            {...rest}
        >
            {children}
        </StyledButton>
    ) : (
        <StyledButtonOutline
            backgroundColor={backgroundColor}
            color={color}
            disabled={disabled}
            size={size}
            {...rest}
        >
            {children}
        </StyledButtonOutline>
    );
};

export { Button };
